var _excluded = ["uppy", "fileId", "closeModal"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect } from 'react';
import Uppy from '@uppy/core';
import { StatusBar } from '@uppy/react';
import { Button } from '@kajabi/sage-react';
import ImageEditor from './ImageEditor';
import './style.scss';

function ImageEditorPanel(_ref) {
  var uppy = _ref.uppy,
      fileId = _ref.fileId,
      closeModal = _ref.closeModal,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      editorMode = _useState2[0],
      setEditorMode = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      uploading = _useState4[0],
      setUploading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      saving = _useState6[0],
      setSaving = _useState6[1];

  var previewMode = !editorMode;
  useEffect(function () {
    var handleEditorComplete = function handleEditorComplete() {
      setSaving(false);
      setEditorMode(false);
    };

    uppy.on('file-editor:complete', handleEditorComplete);
    return function () {
      uppy.off('file-editor:complete', handleEditorComplete);
    };
  }, []);

  var handleSave = function handleSave() {
    setSaving(true);
    uppy.getPlugin('react:ImageEditor').save();
  };

  var handleReset = function handleReset() {
    setEditorMode(true);
  };

  var handleUpload = function handleUpload() {
    setUploading(true);
    uppy.upload().then(closeModal);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "kj-uploader-ImageEditorPanel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kj-uploader-ImageEditorPanel__bar"
  }, /*#__PURE__*/React.createElement(Button, {
    color: Button.COLORS.PRIMARY,
    subtle: true,
    disabled: uploading || editorMode,
    onClick: handleReset
  }, "Reset"), editorMode && /*#__PURE__*/React.createElement(Button, {
    color: Button.COLORS.ACCENT,
    subtle: true,
    disabled: saving,
    onClick: handleSave
  }, "Save"), previewMode && /*#__PURE__*/React.createElement(Button, {
    color: Button.COLORS.ACCENT,
    subtle: true,
    disabled: uploading,
    onClick: handleUpload
  }, "Upload")), /*#__PURE__*/React.createElement("div", {
    className: "kj-uploader-ImageEditorPanel__body"
  }, /*#__PURE__*/React.createElement(ImageEditor, Object.assign({}, rest, {
    uppy: uppy,
    currentFile: uppy.getFile(fileId),
    isVisible: editorMode
  })), previewMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "kj-uploader-ImageEditorPanel__img-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: URL.createObjectURL(uppy.getFile(fileId).data),
    alt: uppy.getFile(fileId).name,
    className: "kj-uploader-ImageEditorPanel__img"
  })), /*#__PURE__*/React.createElement(StatusBar, {
    uppy: uppy,
    hidePauseResumeButton: true,
    hideCancelButton: true
  }))));
}

ImageEditorPanel.defaultProps = {
  closeModal: function closeModal() {}
};
export default ImageEditorPanel;